import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import RadioOption from '../../radio-group/radio-option';
import { getCharByElementPosition } from '../../../lib/exercise';
import MathContent from '../../math-content';
import FluidContainer from '../../layouts/components/fluid-container';
import Spacer from '../../spacer';

const SingleFeedBackContainer = styled.div`
    display: flex;
`;

const RadioOptionFeedbackContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

const Feedback = styled.span`
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0;
    margin-top: 8px;
    margin-right: 48px;
`;

const Label = styled.span`
    font-weight: 600;
    margin-right: 4px;
`;

const RadioOptionContainer = styled.div`
    width: fit-content;
`;

const Index = styled.span`
    font-size: 16px;
    font-weight: 600;
    padding: 9px 18px 0 0;
`;

const getLabel = (hasAnswer, correctSelectedAnswer) => {
    if (!hasAnswer) {
        return 'Risposta non data.';
    }
    return correctSelectedAnswer ? 'Risposta esatta.' : 'Risposta sbagliata.';
};

export const SingleRow = ({
    correctAnswer,
    exerciseId,
    falseString,
    feedback,
    hasAnswer,
    index,
    selectedAnswer,
    trueString,
    showLetter,
}) => {
    const trueLabel = trueString !== '' ? trueString : 'Vero';
    const falseLabel = falseString !== '' ? falseString : 'Falso';
    const correctAnswerText = correctAnswer ? trueLabel : falseLabel;
    const selectedAnswerText = selectedAnswer ? trueLabel : falseLabel;
    const highlightText = !hasAnswer || correctAnswer === selectedAnswer ? 'success' : 'error';
    const label = getLabel(hasAnswer, correctAnswer === selectedAnswer);

    return (
        <SingleFeedBackContainer>
            {showLetter && <Index>{`${getCharByElementPosition(index + 1)}.`}</Index>}
            <RadioOptionFeedbackContainer>
                <RadioOptionContainer>
                    <RadioOption
                        id={exerciseId}
                        checked={true}
                        disabled={true}
                        name={index.toString()}
                        selected={hasAnswer}
                        highlight={highlightText}
                        onChange={() => {}}
                        value="trueFalse"
                    >
                        {!hasAnswer ? correctAnswerText : selectedAnswerText}
                    </RadioOption>
                </RadioOptionContainer>
                <Feedback>
                    <Label>{label}</Label>
                    <MathContent style={{ display: 'inline' }}>{feedback}</MathContent>
                </Feedback>
            </RadioOptionFeedbackContainer>
        </SingleFeedBackContainer>
    );
};

SingleRow.propTypes = {
    correctAnswer: PropTypes.bool,
    exerciseId: PropTypes.number,
    falseString: PropTypes.string,
    feedback: PropTypes.string,
    hasAnswer: PropTypes.bool,
    index: PropTypes.number,
    selectedAnswer: PropTypes.bool,
    trueString: PropTypes.string,
    showLetter: PropTypes.bool,
};

const TrueFalseFeedback = ({ exercise, answers }) => (
    <FluidContainer flexDirection="column" marginRight="regular" marginBottom="mobile" marginTop={['mobile', 'mobile', 'desktop']}>
        {exercise.questions.map((question, index) => {
            const answer = answers.find((item) => item.questionId === `${question.id}`);

            if (!answer) {
                return (
                    <div key={index}>
                        <SingleRow
                            exerciseId={exercise.id}
                            falseString={question.falseString}
                            trueString={question.trueString}
                            index={index}
                            key={index}
                            correctAnswer={question.correct}
                            feedback={question.feedback}
                            hasAnswer={false}
                            showLetter={exercise.questions.length > 1}
                        />
                        {index < exercise.questions.length - 1 && <Spacer size="desktop" />}
                    </div>
                );
            }

            const selectedAnswer = answer.value;
            return (
                <div key={index}>
                    <SingleRow
                        exerciseId={exercise.id}
                        falseString={question.falseString}
                        trueString={question.trueString}
                        correctAnswer={question.correct}
                        feedback={question.feedback}
                        hasAnswer={true}
                        index={index}
                        key={index}
                        selectedAnswer={selectedAnswer}
                        showLetter={exercise.questions.length > 1}
                    />
                    {index < exercise.questions.length - 1 && <Spacer size="desktop" />}
                </div>
            );
        })}
    </FluidContainer>
);

TrueFalseFeedback.propTypes = {
    answers: PropTypes.array,
    exercise: PropTypes.object,
};

export default TrueFalseFeedback;
